import { ConfigContaProyectosService } from 'src/app/services/ConfigContaProyectos.service';
import { StorageService } from 'src/app/services/storage.service';
import { TableFunctionService } from 'src/app/services/table-function.service';
import { ModalBusquedaPlanCuentasComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-plan-cuentas/modal-busqueda-plan-cuentas.component';
import { SubCentroCostosService } from 'src/app/services/sub-centro-costos.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ModalBusquedaProyectosComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proyectos/modal-busqueda-proyectos.component';
import { ModalBusquedaSubCentroComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-sub-centro/modal-busqueda-sub-centro.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistroComprasService } from 'src/app/services/registro-compras.service';
import { obtenerFechaActual, basicAlert, obtenerFechaSeleccionada, alertaConfirmacionHTML, timerOut, obtenerDias, validarCodigoExistentesRC, filtrarCoincidenciaArrayCuenta, alertaRouter, alertaConfirmacion, filtrarCoincidenciaArrayDocume } from 'src/app/shared/utils';
import { Location } from '@angular/common';
import { PlanCuentaService } from 'src/app/services/plancuenta.service';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DecimalPipe, DatePipe } from '@angular/common';
import { DataService } from 'src/app/services/dataService.service';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { ModalBusquedaInterlocutorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-interlocutor/modal-busqueda-interlocutor.component';
import { ProveedorService } from 'src/app/services/proveedor.service'
import { ModalBusquedaProveedorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proveedor/modal-busqueda-proveedor.component';
import { DocumentosCobranzaService } from 'src/app/services/documentos-cobranza.service'
import { ModalBusquedaTdocumentosComponent } from '../busqueda/modal-busqueda-tdocumentos/modal-busqueda-tdocumentos.component';
import { CuentaPorCobrarService } from 'src/app/services/cuentaporcobrar.service'
import { TDocumeRestService } from 'src/app/services/TDocume.service'
import { BuscarService } from 'src/app/services/buscar.service';
import { TableService } from 'src/app/services/ngtable.service';
import { DocumentosAdjuntosService } from 'src/app/services/documentos-adjuntos.service';
import * as FileSaver from 'file-saver';
import { ImagenBase64 } from 'src/app/models/imagenBase64.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-documentos-adjuntos-cab',
  templateUrl: './modal-documentos-adjuntos-cab.component.html',
  styleUrls: ['./modal-documentos-adjuntos-cab.component.css']
})
export class ModalDocumentosAdjuntosCabComponent implements OnInit {


  @ViewChild('interlocutor') interlocutor: ElementRef;
  @ViewChild('mediopago') mediopago: ElementRef;
  @ViewChild('tdocumento') tdocumento: ElementRef;
  @ViewChild('fileUpload') fileUpload: ElementRef;


  @Input() doc_adjuntos: any;
  @Input() editar: boolean;
  @Input() habilitar: any;
  @Input() tipoModal: string;
  @Input() tipoadicionar: any;
  @Input() doc_cliente: any[] = [];
  @Input() dia: any;
  @Input() mes: any;
  @Input() periodo: any;
  @Input() numint: any;
  @Input() tipdoc: any;


  disabledDocume: boolean;
  buscarLimpiarBotonDocume: string;
  public check: boolean = true;
  boolguardar = true;

  constructor(
    private tableFunction: TableFunctionService,
    private proyectoService: ConfigContaProyectosService,
    private SubCentroCostosService: SubCentroCostosService,
    private spinnerService: SpinnerService,
    private modalService: NgbModal,
    private _route: ActivatedRoute,
    private _location: Location,
    private router: Router,
    private cuentasService: PlanCuentaService,
    private registroComprasService: RegistroComprasService,
    private storageService: StorageService,
    private modalServicemodal: NgbActiveModal,
    private decimalPipe: DecimalPipe,
    private DataService: DataService,
    private interlocutorService: InterlocutorService,
    private proveedorService: ProveedorService,
    private documentosCobranzaService: DocumentosCobranzaService,
    private CuentaPorCobrarService: CuentaPorCobrarService,
    private TDocumeRestService: TDocumeRestService,
    private _buscarService: BuscarService,
    private TableService: TableService,
    private DocumentosAdjuntosService: DocumentosAdjuntosService,
    private toastr: ToastrService,

  ) { }
  disabledInterlocutor: boolean = false;
  public buscarLimpiarBoton: string = 'buscar';
  public interlocutores: any[] = [];
  public proveedores: any[] = [];
  comprobantes: any[] = [];
  sessionInfo: any = {};
  lista;
  lista_temp;
  public mediospago: any[] = [];
  documentoscobranza: any[] = [];
  ngOnInit(): void {
    this.sessionInfo = JSON.parse(StorageService.getSession());
    console.log("this.sessionInfo")
    console.log(this.sessionInfo)
    this.getAdjuntos();
  }

  eliminar(data) {
    this.DocumentosAdjuntosService.eliminardocCab(data.id, this.tipdoc, data.numint).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log("-------- ADJUNTOS ------");
      console.log(response)
      this.getAdjuntos();
      this.toastr.success('Se eliminó correctamente.');
    }, err => {
      basicAlert(`Error`, 'warning', 'Aceptar');
      this.spinnerService.activarLoading(false);
    });

  }

  actualizar(data) {
    this.DocumentosAdjuntosService.cabAdjuntoActualizar(data).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log("-------- ADJUNTOS ------");
      console.log(response)
      this.getAdjuntos();
      this.toastr.success('Se modificó correctamente.');
    }, err => {
      basicAlert(`Error`, 'warning', 'Aceptar');
      this.spinnerService.activarLoading(false);
    });

  }

  descargar(data) {

    this.spinnerService.activarLoading(true);
    this.DocumentosAdjuntosService.cabdownloadArchivosAdjuntos(data.id, this.tipdoc, this.numint).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);

      if (response.byteLength > 0) {
        // let file = new Blob([response], { type: 'application/vnd.ms-excel' });
        let file = new Blob([response], { type: data.formato });

        var fileURL = URL.createObjectURL(file);
        FileSaver.saveAs(fileURL, data.nombre);
      } else {
        basicAlert('No hay resultados', 'warning', 'Aceptar', null, null, null);
      }

    }, err => {
      if (err.status == 404) {
        this.spinnerService.activarLoading(false);
        console.log(err);
        basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
    })
  }

  cancelar() {
    this.tipoadicionar = null
    this.modalServicemodal.dismiss('canceling');
  }


  construirobj() {
    let obj: any = {
      // tipo: this.tipo, 
      // docume: this.docume,
      base64: this.base64convertido,
      formato: this.formato,
      nombre: this.nombrearchivo,
      numint: this.numint,
    }

    console.log("obj")
    console.log(obj)
    return obj;
  }

  agregarImagen(obj) {
    this.spinnerService.activarLoading(true);
    this.DocumentosAdjuntosService.docCabImagen(obj).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.getAdjuntos();
      console.log("response agregar");
      console.log(response);
      this.disabledbotonImagen = true;
    }, err => {
      if (err.status == 404) {
        console.log(err);
        basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
    })
  }

  getAdjuntos() {
    //FALTA CORREGIR
    this.spinnerService.activarLoading(true);
    this.DocumentosAdjuntosService.cabBuscarAdjuntos(this.tipdoc, this.numint).subscribe((response: any) => {
      console.log(response);
      this.doc_adjuntos = response.body;
      this.spinnerService.activarLoading(false);

    }, err => {
      if (err.status == 404) {
        this.spinnerService.activarLoading(false);
        console.log(err);
        this.doc_adjuntos = [];
        this.toastr.warning('No hay documentos adjuntos.');
        // basicAlert('Servicio no disponible.', 'warning', 'Aceptar', null, null, null);
      }
    })
  }

  Numarchivos: number = 0
  fileToUpload: FileList = null;
  fileName: string = '';
  handleFileInput(files: FileList) {
    this.spinnerService.activarLoading(true);

    console.log("cantidad de archivos")
    console.log(files.length)
    console.log(files)
    this.fileToUpload = files;
    this.fileName = files.item(0).name;

    for (let i = 0; i < files.length; i++) {
      this.readThis(files.item(i));
    }
    this.spinnerService.activarLoading(false);
  }

  //Reiniciar la cola para poder subir dos veces mismo archivo
  onInputClick(e) {
    e.target.value = '';
  }

  public base64convertido: any;
  public formato: string;
  public size: number;
  public codImagen: string = ''
  public disabledbotonImagen: boolean = true;
  public imagen: any;
  nombrearchivo

  readThis(inputValue: any): void {
    let imageBase64;
    var file: File = inputValue;
    var myReader: FileReader = new FileReader();

    console.log("file");
    console.log(file);



    myReader.onloadend = (e) => {
      imageBase64 = myReader.result;
      console.log(imageBase64);
      this.base64convertido = imageBase64.replace("data:" + file.type + ";base64,", "");
      this.formato = file.type;
      this.size = file.size;
      this.nombrearchivo = file.name;
      let obj: any = {
        base64: this.base64convertido,
        formato: this.formato,
        nombre: this.nombrearchivo,
        numint: this.numint,
        tipdoc:this.tipdoc
      }
      console.log("insertando obj:")
      console.log(obj)
      this.agregarImagen(obj);
    }
    myReader.readAsDataURL(file);
    this.disabledbotonImagen = false;

  }

}
